
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autos-seminuevos/[[...params]]",
      function () {
        return require("private-next-pages/autos-seminuevos/[[...params]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autos-seminuevos/[[...params]]"])
      });
    }
  